import clsx from 'clsx'
import React from 'react'
import {hasActiveStandardsFilter} from 'components/standards-selector/domain/active-filters.cjs'
import {Link} from 'react-router-dom'
import { makeStyles, withStyles} from 'external/material'
import {orderBy} from 'external/lodash'

import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'

import ClearableSelect from 'components/clearable-select'
import SearchPattern from '../components/search-pattern'
import { selectCourseLabel } from 'helpers/quiz'

const useStyles = makeStyles(filterStyles)

export default function AssessmentFilters({context}) {

  const classes = useStyles()
  const {translate, navigate, myCourses, institutionCourses} = context

  const createFilterHandler = (name, mapQuery) => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    const query = mapQuery
      ? mapQuery(context.query, value)
      : {...context.query, [name]: value}
    navigate(undefined, undefined, {query: {...query, page: 1}})
  }

  const courses = context.query.subject
    ? myCourses.filter(({course}) => course.substring(0,2) == context.query.subject)
    : myCourses

  return (<Box className={classes.root}>
    <Box className={classes.filters}>
      {context.quizTypes.length > 0 && (
      <ClearableSelect
        id="quiz-type-filter"
        className={clsx(classes.select, "type")}
        value={context.query.type || ""}
        onChange={createFilterHandler('type')}
        caption={translate('quiz-type')}
      >
        {context.quizTypes.map((type, key) => {
          return (<MenuItem value={type.id} key={key}>{translate(`${type.name}-label`)}</MenuItem>)
        })}
      </ClearableSelect>)}
      {context.mySubjects.length > 0 && (
        <ClearableSelect
          id="quiz-subject-filter"
          className={clsx(classes.select, "subject")}
          value={context.query.subject || ""}
          onChange={createFilterHandler('subject', (query, subject) => ({...query, course: undefined, subject}))}
          caption={translate('subject_label')}
        >
          {context.mySubjects.map((subject, key) => {
            return (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>)
          })}
        </ClearableSelect>
      )}
      {courses.length > 0 && (
        <ClearableSelect
          id="question-bank-course-filter"
          className={clsx(classes.select, "course")}
          value={context.query.course || ""}
          onChange={createFilterHandler('course', (query, course) => {
            return course
              ? {...query, course, subject: course.substring(0,2)}
              : {...query, course: undefined}
          })}
          caption={translate('course_assessment_header')}
        >
          {orderBy(courses, ['course']).map((course, key) => {
            return (<MenuItem value={course.course} key={key}>{selectCourseLabel(course)}</MenuItem>)
          })}
        </ClearableSelect>
      )}
      <Box className={classes.pattern}>
        <SearchPattern path={context.link()} context={context} />
      </Box>
    </Box>
    {!hasActiveStandardsFilter(context.quizStandardFilters) && <Box className={classes.standardsSearch}>
      <Link to={context.link({sectionName: 'standards-search'}, '/:languageId/:role/:page/:tab/:sectionName', {preserveQuery: true})} className={classes.standardsSearchLink}>
        {translate('standards-search')}
      </Link>
    </Box>}
  </Box>
  )
}

function filterStyles(theme) {
  return {
    root: {
      display: "flex",
      paddingTop: 10,
      flexGrow: 1,
      flexDirection: "column",
    },
    standardsSearch: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 5,
      marginBottom: 10
    },
    standardsSearchLink: {
      color: '#009dd8',
      fontSize: '9.5pt'
    },
    filters: {
      flexGrow: 1,
      display: "flex"
    },
    select: {
      marginLeft: 15,
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        marginRight: 15
      },
      '&.type': {
        flexGrow: 1,
        minWidth: 120,
      },
      '&.subject': {
        flexGrow: 1,
        minWidth: 120
      },
      '&.course': {
        flexGrow: 1,
        minWidth: 120
      },
    },
    filler: {
      flexGrow: 1,
    },
    pattern: {
      display: "flex",
      margin: "4px 15px",
      flexDirection: "column",
      justifyContent: "flex-end"
    }
  }
}

